// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2sWqM","label":"Category_label__3pKT_","content":"Category_content__2Y3_w","header":"Category_header__1RVOk","location":"Category_location__1PmyC"};